export default __webpack_public_path__ + "images/crossBlack.v-a588bdf3ff21ecee927a2ed3243bcdef.svg";